<template>
  <!-- Removed "ref='draggable'" as requested -->
  <div class="stacked-images" :style="`transform:scale(${zoom_level || 1})`">
    <!--Base Image-->
    <v-img :width="Dimensions" :height="Dimensions" id="base-image" :src="BaseImage(product)" v-if="IsBuilding" />

    <!--Featured Image-->
    <v-img :width="Dimensions" :height="Dimensions" id="feat-image" :src="ProductImage(product)" v-else />

    <!--Accessories-->
    <transition-group name="stack-fade">
      <img
        v-for="(dataset, key) in validAttachments"
        :key="dataset?.id || key"
        class="img-stack"
        :style="`z-index:${key};${CustomAccessoryCss(dataset)}`"
        :src="DatasetImage(dataset)"
      >
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const props = defineProps<{
  attachments: any[]
  product: any
}>()

const store = useGlobalsStore()
const {
  zoom_level,
  is_mobile
} = storeToRefs(store)

const validAttachments = computed(() => {
  return (props.attachments || []).filter(ds => ds && ds.filename)
})

const have_accessories = computed(() => {
  return props.attachments.length > 0
})

const has_base_img = computed(() => {
  if (!props.product || props.product.base_image == null) return false
  return props.product.base_image.length > 0
})

const IsBuilding = computed(() => {
  return has_base_img.value && have_accessories.value
})

const Dimensions = computed(() => {
  return is_mobile.value ? 250 : 500
})

function CustomAccessoryCss(dataset: any) {
  let csstxt = ""
  const rules = Array.isArray(dataset.rules) ? dataset.rules : (typeof dataset.rules === 'string' ? JSON.parse(dataset.rules || '[]') : [])
  rules.forEach((rule: any) => {
    if (rule.type == 'custom_css') {
      const rule_items = Array.isArray(rule.items) ? rule.items : Object.values(rule.items || {})
      let is_condition_met = 0
      rule_items.forEach((rule_item_id: any) => {
        const find_item = props.attachments.find(ex => ex.id == rule_item_id && ex.selected)
        if (typeof find_item != 'undefined') {
          is_condition_met++
        }
      })
      if (is_condition_met == rule_items.length && rule_items.length > 0) {
        csstxt = rule.css
      }
    }
  })
  return csstxt
}

function BaseImage(prod: any) {
  const url = (import.meta.env.VITE_SERVERAPI_URL || '') + '/storage/uploads/products'
  if (prod?.base_image && prod.base_image.length > 0) {
    return `${url}/base-images/${prod.base_image}`
  } else {
    return `${url}/base-images/_placeholder_.png`
  }
}

function DatasetImage(dataset: any) {
  const url = (import.meta.env.VITE_SERVERAPI_URL || '') + '/storage/uploads/datasets'
  return `${url}/${dataset.filename}`
}

const ProductImage = store.ProductImage


</script>

<style scoped>
/* Product Builder */
.stacked-images {
  transform-origin: center;
  transition: transform 0.3s ease;
  width: fit-content;
  height: fit-content;
  margin: auto;
  position: relative;
  user-select: none;
  -webkit-user-drag: none;
  user-drag: none;

  & img.img-stack {
    position: absolute;
    object-fit: contain;
    top: 0;
    left: 0;
    transition: top 0.35s cubic-bezier(0.4, 0, 0.2, 1), left 0.35s cubic-bezier(0.4, 0, 0.2, 1), transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  }

  & img {
    width: 100%;
    height: 100%;
  }
}

/* Stack enter/leave transition */
.stack-fade-enter-active,
.stack-fade-leave-active {
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.stack-fade-enter-from {
  opacity: 0 !important;
  transform: scale(0.92) !important;
}

.stack-fade-leave-to {
  opacity: 0 !important;
  transform: scale(0.92) !important;
}
</style>
